/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconGenius = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...rest}
    >
      <g clipPath="url(#a)">
        <circle cx={9} cy={9.5} r={8} fill="url(#b)" />
        <path
          fill="#fff"
          d="M8.806 11.75c-2.012 0-3.5-1.31-3.5-3.283V8.44c0-1.973 1.5-3.303 3.526-3.303 2.012 0 3.5 1.303 3.5 3.283v.027c0 1.965-1.5 3.303-3.526 3.303Zm1.712-3.31c0-1.013-.69-1.628-1.705-1.628-1.054 0-1.687.588-1.687 1.6v.028c0 1.013.69 1.628 1.706 1.628 1.054 0 1.686-.588 1.686-1.601V8.44Z"
        />
        <path
          fill="#fff"
          d="M8.711 14.727A5.835 5.835 0 0 1 5.396 13.7l.875-1.392c.715.507 1.616.77 2.543.75a4.858 4.858 0 0 0 1.935-.453c-.466-.878-.728-1.681-.728-2.6l1.584-.182c-.025 1.215.594 2.276 1.425 3.262-.888.94-2.862 1.648-4.178 1.648-.051-.013-.096-.006-.14-.006Zm2.881-7.674-1.577-.142c.083-1.04.766-2.182 1.73-2.911l.92 1.364c-.65.487-1.034 1.216-1.072 1.69Z"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={4.877}
          x2={20.218}
          y1={22.164}
          y2={17.171}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#090171" />
          <stop offset={0.85} stopColor="#FF005A" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 .5h18v17H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default IconGenius;
